<template lang="pug">
.case-container
  .case-content
    .case-case__title
        div(
          style="width:4px;height:80px;background-color: #478bca;"
        )
        .title__content
          span {{ $t('案例分享：维京游轮') }}
          span {{ $t('一价全包欧洲内河游轮。') }}
    .case-case__summary
      div(
        style="margin-right: 300px"
      )
        i.iconfont.iconhangye
        span {{ $t('广告主行业：旅游') }}

      div
        i.iconfont.iconbumen
        span {{ $t('涉及部门：IT部门、运营部门') }}
    .case-case__content__item
        .content__title {{ $t('案例简介：') }}
        .content {{ $t('为维京游轮提供广告及网站监测，收集整合媒体及销售数据并进行挖掘和分析。') }}

    .case-case__content__item
        .content__title {{ $t('客户当前痛点：') }}
        .content 1）{{ $t('客户委托供应商投放广告，但不知实际是否有真实投放，投放的广告位是否合理。') }}
        .content 2）{{ $t('客户广告以官方网站作为承接，但不知广告引流到站情况如何。') }}
        .content 3）{{ $t('客户广告数据、网站数据以及销售数据各自在一个单独的系统，没有一个系统可以把三方打通从而了解从广告投放到实际转化的效果。') }}
    .case-case__content__item
        .content__title {{ $t('复歌解决方案：') }}
        .content {{ $t('我们为客户提供了网站监测服务，并提供Datahub平台收集整合广告、网站以及销售三方数据，让客户在一个平台上了解所有他想看到的一切。具体包括：') }}
        .content 1）{{ $t('广告及网站监测：在客户广告及网站上添加代码，收集广告投放及网站数据。') }}
        .content 2）{{ $t('Datahub平台：清洗、整理并匹配广告、网站及销售三方数据做Cross Channel及Funnel分析。') }}
        .content 3）{{ $t('报告：提供日周月及网站分析报告，分析客户广告投放效果及策略是否有效。') }}
    .case-case__content__item
        .content__title {{ $t('最终结果：') }}
        .content {{ $t('客户对自己的投放情况有了清晰具体的认识，而且不仅可以整体的了解从广告投放到最后转化的情况，还可以分渠道查看，比较各个渠道之间的效果差异，将预算转移至性价比更高的渠道。') }}
  contact
</template>"
<script>
import Contact from '@/components/Contact'
export default {
  components: {
    Contact
  }
}
</script>
